import {autorun} from 'mobx';

import {EntityHeaderFetchHandler} from "../../entity-header/handlers/entity-header.fetch-handler";
import {ROUTE_NAMES} from "../../../../../core/consts";
import {ENTITY_TYPES} from "../../../../../core/app/consts";

export class MegaHeaderFetchHandler extends EntityHeaderFetchHandler {
  entityId: String;

  async onLoaded() {
    const relevantRoutes = [ROUTE_NAMES.competitionScores, ROUTE_NAMES.competitorScores, ROUTE_NAMES.game];

    autorun(() => {
      if(this.state.currentLinkModel && !this.state.isNewEntitiesPages) {
        const nextEntityId: Number = this.nextEntityId(this.state.currentLinkModel);
        const differentEntityId: Boolean = this.entityId !== nextEntityId;
        const isRelevantRoute: Boolean = this.state.currentLinkModel && relevantRoutes.includes(this.state.currentLinkModel.name);

        if (differentEntityId && isRelevantRoute) {
          this.entityId = nextEntityId;
          this.action();
        } else if(!isRelevantRoute) {
          this.entityId = null;
        }

        this._triggerEntityContextChange();
      }
    })
  }

  nextEntityId(linkModel = this.state.currentLinkModel) {
    const entityType = this.nextEntityType(linkModel);

    let id: Number;

    if (entityType === ENTITY_TYPES.competition) {
      id = this.getEntityId(linkModel)
    } else {
      id = linkModel?.params?.id ? parseInt(linkModel?.params?.id) : null
    }

    return `${entityType}_${id}`;
  }

  getEntityId(linkModel): Number {
    let entityId: Number;

    if (linkModel?.params?.id) {
      entityId = parseInt(linkModel?.params?.id);
    } else {
      entityId = parseInt(linkModel?.params.competitionKey?.split('-').last());
    }

    return entityId;
  }

  nextEntityType(linkModel = this.state.currentLinkModel) {
    const types = {
      [ROUTE_NAMES.competitionScores]: ENTITY_TYPES.competition,
      [ROUTE_NAMES.competitorScores]: ENTITY_TYPES.team,
      [ROUTE_NAMES.game]: ENTITY_TYPES.competition,
      [ROUTE_NAMES.trends]: ENTITY_TYPES.competition,
      [ROUTE_NAMES.athlete]: ENTITY_TYPES.athlete,
    };

    return types[linkModel.name];
  }
}
